import { Trans } from 'react-i18next'
import { useTheme } from 'styled-components'

const InfographText = ({ themeKey, i18nKey }) => {
  const theme = useTheme()
  const value = theme?.infograph?.[themeKey]

  if (value && typeof value === 'string' && value.trim()) {
    return <>{value}</>
  }

  return <Trans i18nKey={i18nKey} />
}

export default InfographText
